import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { HomeComponent } from "./components/home/home.component";
import { AuthGuard } from "./services/auth/_guards/auth.guard";
import { LoginComponent } from "./components/app/login/login.component";
import { CompleteComponent } from "./components/complete/complete.component";
import { EditrecipesComponent } from "./components/editrecipes/editrecipes.component";
import { SubproductComponent } from "./components/subproducts/subproducts.component";
import { ProductStructureComponent } from "./components/product-structure/product-structure.component";
import { AnalysisPOComponent } from "./components/analysis-po/analysis-po.component";
import { SalesComponent } from "./components/sales/sales.component";

const routes: Routes = [
  {
    path: "",
    component: HomeComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "complete",
    component: CompleteComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "editrecipes",
    component: EditrecipesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "subproducts",
    component: SubproductComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "subproducts/:id",
    component: SubproductComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "productstructure",
    component: ProductStructureComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "sales",
    component: SalesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "analysis-po",
    component: AnalysisPOComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "auth",
    component: LoginComponent,
  },
  {
    path: "**",
    component: LoginComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { 
      useHash: true,
      enableTracing: false,
     }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
